import { zipPostalRegex } from './regex';

// Check that the input is a valid zip or postal code.
const zipPostalValidation = value =>
	value && !value.match(zipPostalRegex) ? 'Not a valid zip or postal code' : undefined;

export default zipPostalValidation;
